<template>
  <div class=" bg-white p-6 rounded-2xl w-full flex flex-col items-center gap-6">
    <h2 class="text-lg font-medium text-center">Are you sure you want to delete this address?</h2>
    <div class="flex flex-col gap-3 w-full">
      <div class="flex flex-row md:flex-col justify-center items-center gap-4">
  <button
    class="border border-primary text-primary-800 py-[10px] px-[10px] rounded-[8px] w-[163.5px] h-[40px]"
    @click="cancelDelete(); $emit('close')"
  >
    CANCEL
  </button>

  <button
    class="border bg-primary border-primary-800 text-white py-[10px] px-[10px] rounded-[8px] w-[163.5px] h-[40px]"
    @click="confirmDelete(); $emit('confirm')"
  >
    DELETE
  </button>
</div>

    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

onMounted(() => {
  GoogleAnalytics.popUpView({
    [EventParameter.POP_UP_NAME]: 'delete_address',
    [EventParameter.POP_UP_TITLE]: 'Are you sure you want to delete this address?'
  })
});

const confirmDelete = () => {
  GoogleAnalytics.popUpClick({
    [EventParameter.POP_UP_NAME]: 'delete_address',
    [EventParameter.POP_UP_TITLE]: 'Are you sure you want to delete this address?',
    [EventParameter.POP_UP_CTA_NAME]: 'delete'
  });
};

const cancelDelete = () => {
  GoogleAnalytics.popUpClick({
    [EventParameter.POP_UP_NAME]: 'delete_address',
    [EventParameter.POP_UP_TITLE]: 'Are you sure you want to delete this address?',
    [EventParameter.POP_UP_CTA_NAME]: 'cancel'
  });
};
</script>
